import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import Modal from "./Modal";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { api, getListItems } from "../../services/api";

function GalleryFive() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [images, setImages] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.getGallery("about_strip")
      .then((res) => {
        if (cancelled) return;
        const items = getListItems(res).map((item) => item.image).filter(Boolean);
        setImages(items);
      })
      .catch(() => {
        if (!cancelled) setImages([]);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => { cancelled = true; };
  }, []);

  if (!loaded || !images.length) {
    return null;
  }

  const openModal = (imageSrc, event) => {
    event.preventDefault();
    setModalImage(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="sidebar-gallery-area space">
      <div className="container-fluid">
        <div className="slider-area">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            centeredSlides={true}
            loop={images.length > 3}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
              1300: { slidesPerView: 4 },
            }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            className="th-slider has-shadow"
          >
            {images.map((src, idx) => (
              <SwiperSlide key={`${src}-${idx}`}>
                <div className="gallery-card">
                  <div className="box-img global-img">
                    <img src={src} alt={`Gallery ${idx + 1}`} />
                    <Link
                      to={src}
                      className="icon-btn popup-image"
                      onClick={(e) => openModal(src, e)}
                    >
                      <i className="fal fa-magnifying-glass-plus" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
    </div>
  );
}

export default GalleryFive;
